import { createContext, useContext } from 'react'

interface AuthContextValues {
  isLogin: boolean
  login: (email: string, password: string) => Promise<any>
  logout: () => void
  // Interface, organization, and station management
  interfaceId: number | null
  statusInterfaceId: string | null
  orgId: number | null
  stationId: number | null
  setStationId: (id: number | string | null) => void
  setInterfaceId: (id: number | string | null) => void
  setStatusInterfaceId: (status: string | null) => void
  setOrgId: (id: number | string | null) => void
  removeInterfaceId: () => void
  removeOrgId: () => void
  removeStationId: () => void
  // Helper functions for safe API calls
  getValidInterfaceId: () => number | null
  getValidOrgId: () => number | null
  getValidStationId: () => number | null
}

export const AuthContext = createContext<AuthContextValues | undefined>(
  undefined,
)

AuthContext.displayName = 'AuthContext'

export const useAuthContext = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuthContext must be used within a AuthProvider`)
  }
  return context
}
